import React, { useCallback } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Button } from 'ncoded-component-library';
import { DataRoomMember } from 'router/subrouters/DataRoom/models/DataRoomMember';
import {
  getArrayLength,
  getHasElementsInArray,
  getUserFullNameOrEmail,
} from 'utils';
import XIcon from 'icons/X.icon';
import { DataRoomMembersAccessGroup } from 'router/subrouters/DataRoom/models/DataRoomRfi';

import './SelectedMembers.styles.scss';

type SelectedMembersProps = {
  className?: string;
  selectedMembers: DataRoomMember[];
  groups: DataRoomMembersAccessGroup[];
  onRemove: (memberId: string) => void;
  onClearAll: () => void;
};

const SelectedMembers: React.FC<SelectedMembersProps> = (props) => {
  const { className, selectedMembers, groups, onRemove, onClearAll } = props;

  const { t } = useTranslation();

  const classes = classNames('selected-members', className);

  const hasSelectedMembers = getHasElementsInArray(selectedMembers);

  const getGroupName = useCallback(
    (memberId: string) =>
      groups.find((group) => group.members.some(({ _id }) => _id === memberId))
        ?.name,
    [groups],
  );

  return (
    <div className={classes}>
      <div className="selected-members__header">
        <p className="selected-members__title">
          {t('selectedCount', { count: getArrayLength(selectedMembers) })}
        </p>

        {hasSelectedMembers && (
          <Button variant="link" onClick={onClearAll}>
            {t('clearAll')}
          </Button>
        )}
      </div>

      <div className="selected-members__list">
        {hasSelectedMembers ? (
          selectedMembers.map((member) => (
            <div key={member._id} className="selected-members__item">
              <span>{getUserFullNameOrEmail(member)}</span>

              <span className="selected-members__item-group">
                <span>{getGroupName(member._id)}</span>
              </span>

              <Button
                variant="icon"
                icon={XIcon}
                aria-label="Remove"
                onClick={() => onRemove(member._id)}
              />
            </div>
          ))
        ) : (
          <p className="selected-members__placeholder">
            {t('noMembersSelectedForFileAccess')}
          </p>
        )}
      </div>
    </div>
  );
};

export default SelectedMembers;
